import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import logo from "../../assets/black.png";

export default function Footer() {
  return (
    <footer className="bg-white/20 backdrop-blur shadow-inner py-6 mt-10">
      <div className="container mx-auto flex flex-col items-center safe-px gap-5">
        {/* Logo + Iconițe */}
        <div
          className="
            flex flex-col items-center gap-4
            md:flex-row md:justify-around md:w-full
            lg:justify-around lg:w-full
          "
        >
          {/* Logo scalabil */}
          <img
            src={logo}
            alt="ENDOAC Logo"
            className="responsive-logo object-contain cursor-pointer"
            onClick={() => (window.location.href = "/")}
          />

          {/* Iconițe contact (scalabile și ele) */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-5 lg:gap-8">
            <a
              href="https://wa.me/40123456789?text=Salut!+Aș+dori+o+programare"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 hover:scale-110 transition responsive-icon"
              title="WhatsApp Programări"
            >
              <FaWhatsapp />
            </a>
            <a
              href="mailto:contact@clinicamicroscop.ro"
              className="text-blue-700 hover:scale-110 transition responsive-icon"
              title="Trimite email"
            >
              <FaEnvelope />
            </a>
            <a
              href="https://www.google.com/maps?q=Str.+Exemplu+10,+București"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-600 hover:scale-110 transition responsive-icon"
              title="Vezi locația pe Google Maps"
            >
              <FaMapMarkerAlt />
            </a>
          </div>
        </div>

        {/* Text sub logo + iconițe */}
        <p
          className="text-xs sm:text-sm md:text-base font-medium text-center text-gray-900"
        >
          © 2025 ENDOAC. Toate drepturile rezervate.
        </p>
      </div>
    </footer>
  );
}
